var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDecreasedEmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_25343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5723 14.9999H19.2866V9.28564",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2863 15L11.2148 6.92857C11.0813 6.7977 10.9018 6.72439 10.7148 6.72439C10.5279 6.72439 10.3484 6.7977 10.2148 6.92857L6.92913 10.2143C6.79561 10.3452 6.6161 10.4185 6.42913 10.4185C6.24216 10.4185 6.06264 10.3452 5.92913 10.2143L0.714844 5",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_25343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDecreasedEmission);
export default __webpack_public_path__ + "static/media/icon-decreased-emission.d1f7fd1f242323ea05944b5b17a6dd8b.svg";
export { ForwardRef as ReactComponent };